import clsx from 'clsx';

const PRESETS = [
  { value: 'today', label: 'Oggi' },
  { value: '7d', label: '7g' },
  { value: '30d', label: '30g' },
  { value: 'qtr', label: 'Trim.' },
  { value: 'ytd', label: 'Anno' }
];

export function PeriodPicker({ value, onChange }) {
  return (
    <div className="inline-flex items-center rounded-md border border-border-strong bg-surface-elevated p-0.5">
      {PRESETS.map((p) => (
        <button
          key={p.value}
          type="button"
          onClick={() => onChange(p.value)}
          className={clsx(
            'rounded px-2.5 py-1 text-xs font-medium transition-colors',
            value === p.value
              ? 'bg-ink text-white'
              : 'text-ink-muted hover:bg-surface-subtle hover:text-ink'
          )}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
